import HundredBricksAPIError from '../../../HundredBricksAPIError';
class BestOpportunitiesError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('bestOpportunitiesError', ...args);
    }
}
export default BestOpportunitiesError;
